<template>
  <div class="lesson-thumb">
    <img
      v-if="noCoverAndNoPlaceholder"
      class="img-partner-placeholder"
      :src="$setup.partnerLogo"
    />

    <i v-if="isQuiz" class="fa-solid fa-file-pen" />

    <div v-if="style" class="thumb" :style="style" />

    <div v-if="item.is_blocked || isBlocked" class="block">
      <i class="icon-lock text-light"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isQuiz: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    isBlocked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    noCoverAndNoPlaceholder() {
      return (
        !this.isQuiz &&
        !this.item.picture &&
        !this.$setup?.setup?.placeholder_lesson &&
        !this.$setup.setup.logo
      );
    },
    style() {
      if (this.isQuiz) return ``;

      let image =
        this.item.picture ||
        this.$setup?.setup?.placeholder_lesson ||
        this.$setup.setup.logo ||
        false;

      return image ? `background-image: url(${image})` : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-thumb {
  position: relative;
  height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 55%;
  background-color: black;
  margin-bottom: 8px;
  border-radius: 4px;

  .img-partner-placeholder {
    max-height: 48px;
    max-width: 48px;
    min-height: 48px;
    min-width: 48px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .thumb {
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px;
  }

  .block {
    background: rgba(50, 28, 61, 0.8);
    border-radius: 6px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fa-file-pen {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
  }

  .icon-lock {
    font-size: 30px;
  }
}
</style>
